import { Button } from "@mui/material"
import { HelmetComponent } from "../utils/HelmetComponent"
import { useQuery } from "react-query";
import { getData, updateData } from "../utils/api";
import { API_PATH } from "../app.config";
import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showToastError, showToastSuccess } from "../utils/toastUtils";
import Moment from "react-moment";  // Import Moment from 'react-moment'
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Tooltip } from '@mui/material'
import ScrollToTopButton from "../utils/ScrollToTopButton";
import '../assets/css/notification.css'

const NotificationsComponent = (props) => {
    const navigate = useNavigate();
    const [totalNotification, setTotalNotification] = useState(0);
    const [notificationData, setNotificationData] = useState([]);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [event, setEvent] = useState(false);

    const markAsRead = async () => {
        let getResponse = await updateData(API_PATH.markAllRead);
        if (getResponse?.status) {
            showToastSuccess(getResponse.msg);
            setEvent(!event);
            props.eventData();
        } else {
            if (getResponse?.code === 401) navigate('/login');
            else showToastError(getResponse.msg);
        }
    }

    const { data: componentData } = useQuery(['componentData', event, currentPage], () => getData(`${API_PATH.getNotifications}/${currentPage}`));

    useEffect(() => {
        if (componentData) {
            if (componentData?.status) {
                // Use the callback function to update state based on the previous state
                setNotificationData(prevData => [...prevData, ...componentData?.data?.rows]);
                setTotalPageCount(componentData?.data?.count);
            } else {
                if (componentData?.code === 401) navigate('/login');
                // else showToastError(componentData.msg);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentData]);


    useEffect(() => {
        // Attach the scroll event listener
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight) {
                if ((currentPage + 1) <= Math.ceil(totalPageCount / 25)) {
                    setCurrentPage(currentPage + 1);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [currentPage, totalPageCount]);

    const { data: totalData, isLoading } = useQuery(['totalData', event], () => getData(API_PATH.totalNotifications));

    useEffect(() => {
        if (totalData) {
            if (totalData?.status) {
                setTotalNotification(totalData?.data || 0);
            } else {
                if (totalData?.code === 401) navigate('/login');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalData]);

    return <>
        <HelmetComponent title={props?.title} />
        <ScrollToTopButton  />
        <div className="container user-select-none mt-3">
            <Button disabled={totalNotification === 0} variant="outlined" className="mb-1 d-block ms-auto" onClick={markAsRead}>Mark Read All</Button>

            <div className="row d-flex align-items-center justify-content-center mb-5">

                {notificationData.map((item, index) => (
                    <div className="col-12 col-md-8 gy-2" key={index}>
                        <div className={`card ${props?.currentTheme && 'bg-dark text-white'}`}>
                            <div className="card-body">
                                <div className={`d-flex justify-content-between align-items-center ${!item?.seen && 'text-color text-green fw-bold'}`}>
                                    <h6 className={`mb-0 ${item?.seen ? 'text-white': '' }`}>
                                        {item.log}
                                    </h6>
                                </div>

                                <Tooltip title={<Moment utc>{item.createdAt}</Moment>} arrow placement="right">
                                    <div
                                        className={`mb-0 text-end pointer-cursor ${!item?.seen && 'text-color text-green fw-bold'}`}
                                    >

                                        <div className="d-flex float-end">
                                            <AccessTimeIcon className="me-1 text-warning" />
                                            <Moment fromNow utc>{item.createdAt}</Moment>
                                        </div>
                                        
                                    </div>
                                </Tooltip>

                            </div>
                        </div>
                    </div>
                ))}


            </div>

            {isLoading && <h1 className="text-center">Loading ....</h1>}
        </div>
    </>
}

export default memo(NotificationsComponent);